<template>
  <div class="f f-v f-gap-24 f-as">
    <ul class="f f-v f-gap-40 w-100p">
      <li v-for="tag in tags" :key="tag.id" class="m-t0 w-100p">
        <shoutouts-tags-field-set
          :field="tag"
          :committed="isTagCommitted(tag.id)"
          :dirty="dirtyTagsIds.has(tag.id)"
          :disabled="pending.has(tag.id)"
          :on-save="onSaveTag"
          :on-delete="onDeleteTag"
          :upgrade-required="upgradeRequired"
        />
      </li>
    </ul>
    <p class="t">
      Tip: Avoid using any of your Slack #channels as the value tag
    </p>
    <button :class="{ inv: true, disabled: props.upgradeRequired }" @click="addTag">Add row</button>
  </div>
</template>
<script setup>
import { onMounted } from 'vue';
import { useStore } from 'vuex';
import {
  useSharedState,
  setInitialTags,
  addTag,
  commitTag,
  isTagCommitted,
} from './module';

const { tags, pending, dirtyTagsIds } = useSharedState();
const { dispatch, commit } = useStore();

const props = defineProps({
  initialTags: {
    type: Array,
    required: true,
  },
  upgradeRequired: {
    type: Boolean,
    default: false,
  },
});

onMounted(() => {
  setInitialTags(props.initialTags);
});

const onNeedConfirmation = (onConfirm) => (tagId) => {
  window.donut.track('Shoutouts Tags - Open Deletion Confirmation');

  commit(
    'updateModal',
    {
      visible: true,
      subcomponent: 'shoutouts-tags-confirmation-modal',
      size: 'l',
      data: {
        tagId,
        onConfirm,
      },
    },
    { root: true },
  );
};

const onError = (errorCode) => {
  const msg = {
    HASHTAG_ALREADY_USED:
      'Value tag is the same as another value. Please ensure all values tags are unique.',
    EMOJI_ALREADY_USED:
      'Value emoji is the same as another value. Please ensure all value emojis are unique.',
  }[errorCode];

  window.donut.track('Shoutouts Tags - Create or Update Error', { errorCode });

  dispatch('setErrorToast', msg, { root: true });
};
const onSuccessUpdate = () => dispatch('setSuccessToast', 'Shoutout value updated!');
const onSuccessCreate = () => dispatch('setSuccessToast', 'Shoutout value created!');
const onSuccessDelete = () => dispatch('setSuccessToast', 'Shoutout value deleted!');

const onCommitTag = (action, id, confirm, args) => {
  commitTag({
    ...args,
    action,
    id,
    confirm,
    onNeedConfirmation: onNeedConfirmation((additionalArgs) => onCommitTag(action, id, true, additionalArgs)),
    onError,
    onSuccess: {
      create: onSuccessCreate,
      update: onSuccessUpdate,
      delete: onSuccessDelete,
    }[action],
  });
};

const onSaveTag = (id) => {
  const action = isTagCommitted(id) ? 'update' : 'create';
  onCommitTag(action, id);
};
const onDeleteTag = (id) => {
  onCommitTag('delete', id);
};
</script>
